export function extractErrorMessage(error) {
	const response = error.response;
	const status = response?.status;
	const data = response?.data;
	if (data && typeof data === "object" && typeof data.message === "string" && data.message.trim()) {
		return Promise.resolve(data.message);
	}
	if (typeof data === "string") {
		return Promise.resolve(parseBodyText(data) ?? fallbackMessage(status, response));
	}
	if (typeof Blob !== "undefined" && data instanceof Blob) {
		return data
			.text()
			.then(text => {
				const parsed = parseBodyText(text);
				if (parsed) {
					return parsed;
				}
				return fallbackMessage(status, response);
			})
			.catch(() => fallbackMessage(status, response));
	}
	return Promise.resolve(fallbackMessage(status, response));
}

function parseBodyText(text) {
	if (!text || !text.trim()) {
		return null;
	}
	try {
		const parsed = JSON.parse(text);
		if (parsed && typeof parsed === "object") {
			const msg = parsed.message ?? parsed.error ?? parsed.errorMessage;
			if (typeof msg === "string" && msg.trim()) {
				return msg;
			}
		}
		return null;
	} catch {
		return null;
	}
}

function fallbackMessage(status, response) {
	if (!response) {
		return "Network error. Please check your connection.";
	}
	if (status >= 500) {
		return "Server error. Please try again later.";
	}
	if (status === 401) {
		return "Session expired. Please login again.";
	}
	if (status === 404) {
		return "Resource not found.";
	}
	return "Something went wrong. Please try again.";
}
